import { useMediaQuery } from 'usehooks-ts';

export const MOBILE_BREAKPOINT = '(max-width:767px)';

export function useIsMobile(defaultValue = false): boolean {
  return useMediaQuery(MOBILE_BREAKPOINT, {
    defaultValue,
    initializeWithValue: false,
  });
}
